import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from "react-router-dom";
import * as Ant from "antd";
import { ObjectId } from "@bluelibs/ejson";
import { Routes } from "@bundles/UIAppBundle";
import { useUIComponents, useRouter, use, useDataOne, useTranslate, } from "@bluelibs/x-ui";
import { CompanyEditForm } from "../../config/CompanyEditForm";
import { features } from "../../config/features";
import { CompaniesCollection } from "@bundles/UIAppBundle/collections";
const formLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};
const formTailLayout = {
    wrapperCol: { offset: 8, span: 16 },
};
export function CompaniesEdit(props) {
    const UIComponents = useUIComponents();
    const t = useTranslate();
    const form = use(CompanyEditForm, { transient: true });
    const router = useRouter();
    const collection = use(CompaniesCollection);
    const { data: document, isLoading, error, } = useDataOne(CompaniesCollection, new ObjectId(props.id), CompanyEditForm.getRequestBody());
    form.build();
    return (_jsx(UIComponents.AdminLayout, { children: _jsxs("div", Object.assign({ className: "bg-white" }, { children: [_jsx(Ant.PageHeader, { title: t("management.companies.edit.header"), onBack: () => window.history.back(), extra: features.view
                        ? [
                            _jsx(Link, Object.assign({ to: router.path(Routes.COMPANIES_VIEW, {
                                    params: { id: props.id },
                                }) }, { children: _jsx(Ant.Button, { children: t("generics.view") }, void 0) }), "view"),
                        ]
                        : [] }, void 0), _jsxs(Ant.Card, { children: [isLoading && (_jsx(Ant.Space, Object.assign({ align: "center" }, { children: _jsx(Ant.Spin, { size: "large" }, void 0) }), void 0)), !isLoading && (error || !document) && (_jsx(Ant.Alert, { message: error || t("generics.error_message"), type: "error" }, void 0)), !isLoading && !error && (_jsxs(Ant.Form, Object.assign({}, formLayout, { requiredMark: "optional", initialValues: document, onFinish: (document) => form.onSubmit(props.id, document) }, { children: [form.render(), _jsx(Ant.Form.Item, Object.assign({}, formTailLayout, { children: _jsx(Ant.Button, Object.assign({ type: "primary", htmlType: "submit" }, { children: t("generics.submit") }), void 0) }), void 0)] }), void 0))] }, void 0)] }), void 0) }, void 0));
}
